class CollapsibleContent extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector("button");
    const content = button.nextElementSibling;

    button.addEventListener("click", () => {
      this.lockProductInfoOffset();

      const ariaExpanded = button.getAttribute("aria-expanded");
      if (ariaExpanded === "true") {
        button.setAttribute("aria-expanded", "false");
        content.setAttribute("aria-hidden", "true");
      } else {
        button.setAttribute("aria-expanded", "true");
        content.setAttribute("aria-hidden", "false");
      }
    });
  }

  lockProductInfoOffset() {
    const productInfo = this.closest('product-info');
    if (!productInfo || productInfo.classList.contains('product-info--offset-locked')) return;

    const offset =
      productInfo.getBoundingClientRect().top - productInfo.parentElement.getBoundingClientRect().top;

    productInfo.style.setProperty('--product-info-offset', `${offset}px`);
    productInfo.classList.add('product-info--offset-locked');
  }
}

customElements.define('collapsible-content', CollapsibleContent);
